// Файл interface_profile_transport.js
/**
 * Модуль отправляет запрос профиля интерфейса.
 * Он управляет состоянием выполняющегося запроса.
 * Код использует существующие компоненты и зависимости этого раздела.
 * Его функции участвуют в работе соответствующей страницы или сервиса.
 */


let profile_request = null;



const request_interface_profile = (api_service) => {
    if (profile_request) {
        return profile_request;
    }

    const request = api_service.df({
        table_name: 'interface_customization_settings',
    });
    const tracked_request = request.finally(() => {
        if (profile_request === tracked_request) {
            profile_request = null;
        }
    });

    profile_request = tracked_request;

    return tracked_request;
};


export { request_interface_profile };
